/**
 * Kunskapsartiklar som rankar på kommersiella sökningar ska leda vidare till
 * rätt tjänstesida i stället för att konkurrera med den.
 *
 * Underlag: Google Search Console 2026-08-06 – 2026-09-02. Exempel:
 * "företagsfilm" gav 656 visningar och 1 klick, och det var artikeln
 * /kunskap/vad-ar-en-foretagsfilm (pos 15,4) som visades — inte tjänstesidan.
 */
export type ArticleServiceCta = {
  /** Kort rad som förklarar nästa steg. */
  body: string;
  label: string;
  to: string;
};

export const ARTICLE_SERVICE_CTA: Record<string, ArticleServiceCta> = {
  "vad-ar-en-foretagsfilm": {
    body: "Vill ni beställa en företagsfilm i stället för att läsa om den? Se format, process och vad som ingår.",
    label: "Till företagsfilm",
    to: "/foretagsfilm",
  },
  "vad-kostar-en-foretagsfilm": {
    body: "Räkna fram er nivå direkt, eller be om fast pris på en företagsfilm.",
    label: "Till företagsfilm",
    to: "/foretagsfilm",
  },
  "skillnad-reklamfilm-foretagsfilm": {
    body: "Vet ni redan vilket format ni vill ha? Gå direkt till tjänstesidan.",
    label: "Till reklamfilm",
    to: "/reklamfilm",
  },
  "vad-ar-en-aftermovie": {
    body: "Har ni ett event på gång? Vi filmar och levererar reels samma dag.",
    label: "Till eventfilm",
    to: "/eventfilm",
  },
  "dronarfilm-regler-pris-nar-det-funkar": {
    body: "Behöver ni luftbilder med certifierad pilot och tillstånd på plats?",
    label: "Till drönarfilm",
    to: "/dronarfilm",
  },
  "vad-ar-dronarfilm": {
    body: "Behöver ni luftbilder med certifierad pilot och tillstånd på plats?",
    label: "Till drönarfilm",
    to: "/dronarfilm",
  },
  "vad-ar-en-explainer-video": {
    body: "Ska ni förklara en tjänst eller produkt? Vi producerar animerad förklaringsfilm.",
    label: "Till motion graphics",
    to: "/motion-graphics",
  },
  "3d-animation-vs-live-action-nar-valja-vad": {
    body: "Har ni en fysisk produkt att visa? Skicka CAD så visualiserar vi den.",
    label: "Till produktvisualisering",
    to: "/3d-produktvisualisering",
  },
  "vad-ar-en-reklamfilm": {
    body: "Ska ni producera reklamfilm? Se koncept, process och prisnivåer.",
    label: "Till reklamfilm",
    to: "/reklamfilm",
  },
  "vad-ar-employer-branding-film": {
    body: "Ska ni visa hur det är att jobba hos er? Vi producerar employer branding-film.",
    label: "Till employer branding",
    to: "/employer-branding-film",
  },
};
